import { AbstractControl, Validators } from '@angular/forms';
import { createValidationError, PcsValidationErrors } from '@app/shared/validators/validation-errors';
import { hasValue, isNumber } from '@util';
import { maxLength as ngrxMaxLength } from 'ngrx-forms/validation';

const defaultMessage = 'general.message.maxLength';

export const maxLengthValidator = (maxLength: number, message: string = defaultMessage) =>
  (control: AbstractControl): PcsValidationErrors => {
    if (Validators.maxLength(maxLength)(control)) {
      return createValidationError('maxLength', message, [String(maxLength)]);
    }
  };

export const maxLength: any = (length: number) => (val: any): any => {
  const value =  isNumber(val) ? val.toString() : val;
  const errors = ngrxMaxLength(length)(value);
  return hasValue(errors) ? createValidationError('maxLength', defaultMessage, [String(length)]) : null;
};
